import { render, staticRenderFns } from "./ExpertTermsRemindersPagination.vue?vue&type=template&id=100e22fc&scoped=true"
import script from "./ExpertTermsRemindersPagination.vue?vue&type=script&lang=js"
export * from "./ExpertTermsRemindersPagination.vue?vue&type=script&lang=js"
import style0 from "./ExpertTermsRemindersPagination.vue?vue&type=style&index=0&id=100e22fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "100e22fc",
  null
  
)

export default component.exports